<template>
  <div class="travel-gallery">
    <div class="image-gallery">
      <div class="row">
        <div :class="getImageGridClass(key)" v-for="(e, key) in elements">
          <lazy-youtube class="travel-gallery-video" v-if="e.url" :src="e.url | cleanVideoUrl" :custom-thumbnail="e.vorschaubild ? getLargestAvailableImage(e.vorschaubild.filenames) : ''"/>
          <a  v-if="e.filenames && getLargestAvailableImage(e.filenames)"
              class="travel-gallery-image img-link"
              :data-fancybox="fancyboxGroup"
              :data-caption="mergeImageInfo(e)"
              :href="e.filenames.zoomed ? e.filenames.zoomed : getLargestAvailableImage(e.filenames)"
              :title="mergeImageInfo(e)">
            <responsive-image :alt="e.legende"
                              :title="mergeImageInfo(e)"
                              :src="e.filenames.jpg_fallback_3x2"
                              :src-xs="e.filenames.img800_3x2"
                              :src-sm="e.filenames.img400_3x2"
                              :src-md="e.filenames.img400_3x2"
                              :src-lg="e.filenames.img800_3x2"
                              :fixed-aspect-ratio="3/2"
                              img-class="travel-detail-picture img-responsive"/>
            <span class="travel-gallery-image-count" v-if="key == 4 && extraImageCount > 0">+ {{ extraImageCount }} Fotos</span>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>
<style></style>
<script type="module">
import HelperMixin from "../mixins/helper-mixin";

export default {
  name: "travel-gallery",
  props: {
    videos: {
      type: Array
    },
    bilder: {
      type: Array
    },
    fancyboxGroup: {
      type: String,
      default: 'gallery'
    },
    excludes: {
      type: Array,
      default: []
    }
  },
  mixins: [HelperMixin],
  data: function () {
    return {}
  },
  computed: {
    elements: function(){
      var images = [];
      var videos = (this.videos)?this.videos:[];
      for(let i = 0; i < this.bilder.length; i++){
        var img = this.bilder[i];
        if(img.bild != 'hauptbild' && !this.excludes.includes(i)){
          images.push(img);
        }
      }
      return [...videos, ...images];
    },
    hasVideo: function () {
      if (this.videos && this.videos.length > 0) return 1;
      return 0;
    },
    extraImageCount: function() {
      return (this.objectCount - 5);
    },
    objectCount: function() {
      return (this.elements.length);
    }
  },
  methods: {
    getImageGridClass: function(key){
      var c = [];
      if(this.objectCount == 1 && key == 0) c.push('col-xs-12 no-margin');
      if(this.objectCount == 2 || this.objectCount == 4){
        c.push('col-sm-6');
      }
      if(this.objectCount == 3){
        c.push('col-sm-4');
      }
      if(this.objectCount >= 5){
        if(key <= 1)c.push('col-sm-6');
        else if(key == 4 && this.extraImageCount > 0){
          c.push('col-sm-4');
          c.push('last');
        }
        else if(key <= 4)c.push('col-sm-4');
        else c.push('hidden');
      }
      return c.join(' ');
    },

    mergeImageInfo: function (image) {
      if (!typeof image === 'Object') return '';
      var string = '';
      if (image.hasOwnProperty('legende')) {
        string += image.legende;
      }
      if (image.hasOwnProperty('copyright')) {
        string += ' ©' + image.copyright;
      }
      return string;
    }
  },
  filters: {
    cleanVideoUrl: function (videoUrl) {
      videoUrl = videoUrl.replace('https://youtu.be/','https://www.youtube.com/watch?v=');
      videoUrl = videoUrl.replace('http://youtu.be/','http://www.youtube.com/watch?v=');
      //videoUrl = videoUrl.replace(new RegExp("watch\\?v=", "i"), 'v/');
      videoUrl += '?rel=0';
      return videoUrl;
    }
  }
}
</script>